import React from 'react'
import './footer.css'
import {NavLink} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faLocation, faPhone, faEnvelope} from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faInstagramSquare, faLinkedin, faYoutubeSquare, faTwitterSquare } from '@fortawesome/free-brands-svg-icons'

const Footer = () => {
  return (
    <>
      <section class="footersection">
	<div class="container">
		<div class="row">
			<div class="col-md-4">
				<h3>For more information</h3>
				<div class="footline"></div>
				<p>We are eagerly waiting for your suggestions.<br/>Kindly follow us for more support.</p>
			</div>
			<div class=" footerr2 col-md-2 ">
				<h3>Quick Links:</h3>
				<div class="footline"></div>
				<li><NavLink className="nav-link" to="/">Government</NavLink></li>
				<li><NavLink className="nav-link" to="/">Department</NavLink></li>
				<li><NavLink className="nav-link" to="/">Residences</NavLink></li>
				<li><NavLink className="nav-link" to="/">Business</NavLink></li>
			</div>
			<div class=" footerr2 col-md-2 ">
				<h3>Helpful Links:</h3>
				<div class="footline"></div>
				<li><NavLink className="nav-link" to="/">Payment</NavLink></li>
				<li><NavLink className="nav-link" to="/">Terms</NavLink></li>
				<li><NavLink className="nav-link" to="/">News</NavLink></li>
				<li><NavLink className="nav-link" to="/">Events</NavLink></li>
				<li><NavLink className="nav-link" to="/">Service</NavLink></li>
				<li><NavLink className="nav-link" to="/">Contact</NavLink></li>
			</div>
			<div class=" footerr2 col-md-2 ">
				<h3>Departments:</h3>
				<div class="footline"></div>
				<li><NavLink className="nav-link" to="/">Administration</NavLink></li>
				<li><NavLink className="nav-link" to="/">Community Development / Planning</NavLink></li>
				<li><NavLink className="nav-link" to="/">Environmental Services</NavLink></li>
				<li><NavLink className="nav-link" to="/">Finance</NavLink></li>
				<li><NavLink className="nav-link" to="/">Health and Human Services</NavLink></li>
				<li><NavLink className="nav-link" to="/">Municipal Boards</NavLink></li>
				<li><NavLink className="nav-link" to="/">Public Safety Department</NavLink></li>
				<li><NavLink className="nav-link" to="/">Transportation and Parking</NavLink></li>
				<li><NavLink className="nav-link" to="/">Other Services</NavLink></li>
			</div>
			{/* <div class=" footer3 col-md-4">
				<h3>Contact Us</h3>
				<div class="footline"></div>
				<li><FontAwesomeIcon icon={faLocation}></FontAwesomeIcon> Nashik, Maharashtra</li>
				<li><FontAwesomeIcon icon={faPhone}></FontAwesomeIcon> +91-9860363068</li>
				<li><FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon> contact@dhindoraa.com</li>
			</div> */}
		</div>
		<div class="row">
			<div class="col-lg-12 col-md-12 col-12 social-div text-center mt-3 line-spacing-1">
                <a href="https://twitter.com/earthid_ssi" target="_blank"><FontAwesomeIcon className='fontIconnFoot' icon={faTwitterSquare}/></a>
				<a href="https://www.youtube.com/channel/UCaRjLyN4I_0UrK3NL4zU1Vg/featured" target="_blank"><FontAwesomeIcon className='fontIconnFoot' icon={faYoutubeSquare}/></a>
				<a href="https://www.facebook.com/myearth.id/" target="_blank"><FontAwesomeIcon className='fontIconnFoot' icon={faFacebook}/></a>
				<a href="https://www.instagram.com/myearthid/" target="_blank"><FontAwesomeIcon className='fontIconnFoot' icon={faInstagramSquare}/></a>
				<a href="https://www.linkedin.com/company/myearthid/" target="_blank"><FontAwesomeIcon className='fontIconnFoot' icon={faLinkedin}/></a>
			</div>
		</div>
		<hr/>
		<div class="mt-10 text-center rightsSec">
			<p>© 2023 EarthID, Inc. All Rights Reserved.</p>
		</div>
	</div>
</section>

    </>
  )
}

export default Footer
